import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { AfterViewInit, Component, ElementRef, HostBinding, HostListener, inject, ViewChild } from '@angular/core';
import { NavigationEnd } from '@angular/router';
import { FullscreenService } from '@shared/services/fullscren.service';
import { filter } from 'rxjs';
import { environment } from '../environments/environment';
import { SideNavService } from './core/shared/services/side-nav.service';
import { BaseComponent } from './core/utilities/base-component/base-component';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  animations: [
    trigger('slideOpenClose', [
      state('open', style({ width: '28%' })),
      state('close', style({ width: '5%' })),
      state('void', style({ width: '0', overflow: 'hidden' })),
      transition('open <=> close', animate('400ms ease-in-out')),
    ]),
  ],
})
export class AppComponent extends BaseComponent implements AfterViewInit {
  public isLoginPage: boolean = true;
  public externalRequest: boolean = true;
  public title = 'sigecom';

  public hideSideNav: boolean = false;
  public hideSideNavAnimation: 'open' | 'close' | 'void' = 'open';

  public isFullscreen = false;
  public isMobile: boolean = false;
  @HostBinding('style.--app-header-height.px')
  public headerHeight = 0;

  readonly #sideNavService = inject(SideNavService);
  readonly #fullscreenService = inject(FullscreenService);

  public fullscreen$ = this.#fullscreenService.fullscreen$;
  @ViewChild('appHeader', { read: ElementRef })
  private appHeaderRef?: ElementRef<HTMLElement>;

  constructor() {
    super();
  }

  ngAfterViewInit(): void {
    this.updateHeaderHeight();
  }

  @HostListener('window:resize')
  onResize() {
    this.checkMobile();
    this.updateHeaderHeight();
  }

  private checkMobile() {
    this.isMobile = window.innerWidth < 768;
    if (this.isMobile) {
      this.hideSideNavAnimation = 'void';
    }
  }

  ngOnInit(): void {
    this.checkMobile();
    this.#sideNavService.isHide
      .pipe(this.takeUntilDestroy())
      .subscribe((value) => {
        this.hideSideNav = value;
        if (!this.isMobile) {
          this.hideSideNavAnimation = value ? 'close' : 'open';
        }
      });

    this.authService.verifyTokenAndSetupData();
    console.log(environment.apiUrl);
    this.router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event) => {
        this.isLoginPage = (event as NavigationEnd).url.includes('/login');
        this.updateHeaderHeight();
      });

    this.router.events.subscribe((firedEvent) => {
      if (firedEvent instanceof NavigationEnd) {
        this.externalRequest = firedEvent.url.includes('/app');
        this.updateHeaderHeight();
      }
    });
  }

  private updateHeaderHeight(): void {
    requestAnimationFrame(() => {
      this.headerHeight = this.appHeaderRef?.nativeElement?.offsetHeight ?? 0;
    });
  }

  protected readonly environment = environment;
}
